export const LINK_ANDROID = "https://play.google.com/store/apps/details?id=pt.unloop.MissionMasters";
export const LINK_IOS = "";
